var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProfileLinkedIn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 64,
    viewBox: "0 0 65 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.882812,
    width: 64,
    height: 64,
    rx: 32,
    fill: "#F7F8FE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.5831 46.84H15.1527V22.9117H22.5831V46.84ZM18.8634 19.6477C16.4877 19.6477 14.5601 17.679 14.5601 15.3034C14.5601 14.162 15.0134 13.0675 15.8205 12.2604C16.6275 11.4534 17.7221 11 18.8634 11C20.0047 11 21.0993 11.4534 21.9064 12.2604C22.7134 13.0675 23.1668 14.162 23.1668 15.3034C23.1668 17.679 21.2391 19.6477 18.8634 19.6477ZM50.3924 46.84H42.9786V35.192C42.9786 32.4157 42.9223 28.856 39.1156 28.856C35.2525 28.856 34.6599 31.8717 34.6599 34.9923V46.84H27.2372V22.9117H34.3629V26.1757H34.4666C35.4586 24.2954 37.8817 22.3114 41.4964 22.3114C49.0164 22.3114 50.3988 27.2637 50.3988 33.6957V46.84H50.3924Z",
    fill: "#4540DB"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileLinkedIn);
export default __webpack_public_path__ + "static/media/Profile_LinkedIn.00e274540200ba7ca7545d04eaf5ae0f.svg";
export { ForwardRef as ReactComponent };